import {Routes} from '@angular/router';
import {MaDashboardComponent} from '@ma-dashboard/ma-dashboard.component';
import {MaDashboardWelcomeComponent} from '@ma-dashboard/ma-dashboard-welcome/ma-dashboard-welcome.component';
import {CyclesComponent} from '@ma-dashboard/cycles/cycles.component';
import {MaDashboardProductsComponent} from '@ma-dashboard/ma-dashboard-products/ma-dashboard-products.component';
import {MaProductViewComponent} from '@ma-dashboard/ma-product-view/ma-product-view.component';
import {HandelspartnerComponent} from '@ma-dashboard/handelspartner/handelspartner.component';
import {VotingOverviewComponent} from '@ma-dashboard/voting-overview/voting-overview.component';
import {ProductEditorComponent} from '@dashboard/product-editor/product-editor.component';
import {MailjetExportComponent} from '@ma-dashboard/mailjet-export/mailjet-export.component';
import {RegistrationDebuggerComponent} from '@ma-dashboard/registration-debugger/registration-debugger.component';
import {UserListComponent} from '@ma-dashboard/users/userlist/user-list.component';
import {EditUserComponent} from '@ma-dashboard/users/edit/edit-user.component';
import {UserRoleRouteGuard, UserType} from '@common/messe-ui-toolkit';
import {MaDashboardRelativeRouteBuilder} from '@util/route-builder';

export const MA_DASHBOARD_ROUTES: Routes = [
  {
    path: '',
    component: MaDashboardComponent,
    data: {allowedUserGroups: UserType.MA},
    canActivate: [UserRoleRouteGuard],
    children: [
      {path: '', pathMatch: 'full', redirectTo: MaDashboardRelativeRouteBuilder.welcome().buildRelative()},
      {path: MaDashboardRelativeRouteBuilder.welcome().buildRelative(), component: MaDashboardWelcomeComponent},
      {path: MaDashboardRelativeRouteBuilder.cycles().buildRelative(), component: CyclesComponent},
      {path: MaDashboardRelativeRouteBuilder.handelspartner().buildRelative(), component: HandelspartnerComponent},
      {path: MaDashboardRelativeRouteBuilder.products().buildRelative(), component: MaDashboardProductsComponent},
      {path: MaDashboardRelativeRouteBuilder.voting().buildRelative(), component: VotingOverviewComponent},
      {path: MaDashboardRelativeRouteBuilder.voting(':cycleId').buildRelative(), component: VotingOverviewComponent},
      {path: MaDashboardRelativeRouteBuilder.mailjetExport().buildRelative(), component: MailjetExportComponent},
      {path: MaDashboardRelativeRouteBuilder.registrationDebugger().buildRelative(), component: RegistrationDebuggerComponent},
      {path: MaDashboardRelativeRouteBuilder.productView(':productId').buildRelative(), component: MaProductViewComponent},
      {path: MaDashboardRelativeRouteBuilder.productView(':productId', ':cycleId').buildRelative(), component: MaProductViewComponent},
      {path: MaDashboardRelativeRouteBuilder.productEdit(':productId').buildRelative(), component: ProductEditorComponent},
      {path: MaDashboardRelativeRouteBuilder.users().buildRelative(), component: UserListComponent},
      {path: MaDashboardRelativeRouteBuilder.editUser(':mnetId').buildRelative(), component: EditUserComponent},
    ],
  },
];
